import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { singularize, toCamelCase, toPascalCase } from '@cli-utils/text.js'
import { renderGenM2mFilesRenderer } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-m2m-files.js'

export function genM2MFiles(ctx: EntityCtx): Array<{ name: string; content: string }> {
  const files: Array<{ name: string; content: string }> = []

  for (const f of ctx.m2mFields) {
    const rel = f.relationship || ''
    const RelPascal = toPascalCase(rel)
    const relSingular = singularize(rel)
    const junctionVar = toCamelCase(`${ctx.singular}${RelPascal}`)
    const entityIdCol = `${ctx.singular}Id`
    const relIdCol = `${relSingular}Id`
    const kebabRel = rel
      .replace(/([A-Z])/g, '-$1')
      .toLowerCase()
      .replace(/^-/, '')

    files.push({
      name: `get-${kebabRel}-for-${ctx.singular}.ts`,
      content: renderGenM2mFilesRenderer({
        kind: 'renderGenM2MFilesServerActionTemplate',
        props: {
          junctionVar: junctionVar,
          ctxCacheReadImport: ctx.cacheReadImport,
          ctxCamelPlural: ctx.camelPlural,
          relPascal: RelPascal,
          ctxSingular: ctx.Singular,
          ctxSingularText: ctx.singular,
          ctxCacheLifeLine: ctx.cacheLifeLine,
          relIdCol: relIdCol,
          entityIdCol: entityIdCol,
          rel: rel
        }
      })
    })

    files.push({
      name: `set-${kebabRel}-for-${ctx.singular}.ts`,
      content: renderGenM2mFilesRenderer({
        kind: 'renderGenM2MFilesServerActionDetailsTemplate',
        props: {
          junctionVar: junctionVar,
          ctxTableVar: ctx.tableVar,
          ctxCacheInvalidationFn: ctx.cacheInvalidationFn,
          ctxCamelPlural: ctx.camelPlural,
          ctxSingular: ctx.Singular,
          relPascal: RelPascal,
          ctxSingularText: ctx.singular,
          rel: rel,
          fName: f.name,
          ctxPlural: ctx.plural,
          entityIdCol: entityIdCol,
          relSingular: relSingular,
          relIdCol: relIdCol
        }
      })
    })
  }

  return files
}
